// IMPORTANT: THIS FILE IS AUTO GENERATED! DO NOT MANUALLY EDIT OR CHECKIN!

/* tslint:disable */
export const VERSION = {
  version: "7.1.0",
  date: "2026-06-09T13:06:53.425Z",
  gitInfo: {
    dirty: false,
    raw: "04c57c812",
    hash: "04c57c812",
    distance: null,
    tag: null,
    semver: null,
    suffix: "04c57c812",
    semverString: null
  }
};
/* tslint:enable */
